import { registerPlugin } from '@capacitor/core';
const YoutubePlayer = registerPlugin('YoutubePlayer', {
    web: () => import('./web').then(m => new m.YoutubePlayerPluginWeb()),
});
export * from './definitions';
export { YoutubePlayer };
//# sourceMappingURL=index.js.map